<template>
  <v-container fluid class="px-0 py-0">
    <v-autocomplete
        ref="autocomplite"
        v-if="!!aggregateSelectStore && !!aggregateSelectStore.rootData"
        v-bind="$attrs"
        :value="value"
        cache-items
        :search-input="storeSelectedTable.search"
        dense
        :items="proxyList"
        :multiple="multiple"
        :item-text="itemText"
        item-value="uid"
        :outlined="outlined"
        append-icon="mdi-refresh"
        clearable
        :prepend-icon="prependIcon"
        @click:append="onRefresh()"
        @input="onInput($event)"
        @update:search-input="onUpdateSearch($event)"
    >
      <template v-slot:prepend>
        <slot name="prepend"></slot>
      </template>
      <template v-slot:append-item>
        <div v-intersect="endIntersect"/>
      </template>
    </v-autocomplete>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore, useBaseAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import {debounce} from "debounce";

export default {
  name: "CommonPartialSelectFromTable",

  props: {
    value: {default: null},
    itemText: {default: 'name'},
    prependIcon: {default: null},
    dtoListQuery: {type: [String], default: null},
    sortBy: {default: null},
    sortDesc: {
      default() {
        return [true]
      }
    },
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    aggregateSelectStoreName: {
      default() {
        return uuidv4().toString().replace(/-/g, '')
      }
    },
    showSelect: {default: true},
    singleSelect: {default: false},
    multiple: {type: [Boolean], default: false},
    outlined: {type: [Boolean], default: true},
    itemsPerPage: {default: 20},
    queryFilters: {default: null},
  },

  components: {},

  computed: {
    proxyList() {
      // console.log('proxyList', this.value)
      if (!!this.value && !!this.aggregateStore && !!this.aggregateStore.rootData && !!this.aggregateStore.rootData[this.value]) {
        this.storeSelectedTable.proxyList.push(this.aggregateStore.rootData[this.value])
      }
      return this.storeSelectedTable.proxyList
    },
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
        // console.log('watch value', this.storeName)
        if (!!this.value) {
          this.storeSelectedTable.search = this.aggregateStore.rootData[this.value][this.itemText]
        } else {
          this.storeSelectedTable.search = null
        }
        this.onRefresh()
      },
      deep: true
    },
  },

  methods: {
    endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        // console.log('endIntersect', entries, observer, isIntersecting)
        this.storeSelectedTable.options.page += 1
        this.onRefresh()
      }
    },
    onUpdateSearch(event) {
      // console.log('onUpdateSearch', event)
      this.storeSelectedTable.options.page = 1
      this.storeSelectedTable.quick_search_flag = true
      this.storeSelectedTable.search = event
      this.onRefresh()
    },
    onRefresh() {
      this.storeSelectedTable.update()
    },
    onInput(uid) {
      if (!(uid in this.aggregateStore.uid_dict))
        this.aggregateStore.uid_dict[uid] = this.aggregateSelectStore.uid_dict[uid]
      if (!(uid in this.aggregateStore.rootData))
        this.aggregateStore.rootData[uid] = this.aggregateSelectStore.rootData[uid]
      this.$emit('input', uid)
    },
  },

  async mounted() {
    // console.log('CommonPartialSelectFromTable mounted', this.storeName)
    this.aggregateStore = useAggregateStore()
    this.aggregateSelectStore = useBaseAggregateStore(this.aggregateSelectStoreName)()
    this.storeSelectedTable = useTableStore(this.storeName, this.aggregateSelectStoreName)()
    this.storeSelectedTable.dtoListQuery = this.dtoListQuery
    this.storeSelectedTable.singleSelect = this.singleSelect
    this.storeSelectedTable.options.itemsPerPage = this.itemsPerPage
    this.storeSelectedTable.options.sortBy = this.sortBy
    this.storeSelectedTable.options.sortDesc = [true, true, true, true, true, true, true]
    this.storeSelectedTable.options.page = 1
    this.storeSelectedTable.query_filters = this.queryFilters
    if (!!this.value && !!this.aggregateStore && !!this.aggregateStore.rootData && !!this.aggregateStore.rootData[this.value])
      this.storeSelectedTable.earch = this.aggregateStore.rootData[this.value][this.itemText]
    else
      this.storeSelectedTable.update()
  },

  beforeDestroy() {
    // console.log('beforeDestroy', this.aggregateSelectStoreName, this.storeName)
    this.aggregateSelectStore.$reset()
  },

  data() {
    return {
      items: [],
      aggregateStore: null,
      aggregateSelectStore: null,
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>

<i18n src="@/components/Common/locales.json">
</i18n>